// Wrappers around the presentational RoleSelectPanelView.
//
// The views take paddingBottomClassName as a prop and have no app coupling;
// these wrappers supply the anchored-ad padding so call-sites keep the
// original API.
import * as View from "./RoleSelectPanelView";

export type {
  RoleOption,
  RolePositionGroup,
  RoleSelectPanelProps,
} from "./RoleSelectPanelView";

type SheetContentProps = Parameters<typeof View.RoleSelectSheetContent>[0];

export const RoleSelectSheetContent = (props: SheetContentProps) => (
  <View.RoleSelectSheetContent
    {...props}
    paddingBottomClassName="ad-gutter-pad"
  />
);

export const RoleSelectPanel = (props: View.RoleSelectPanelProps) => (
  <View.RoleSelectPanel {...props} paddingBottomClassName="ad-gutter-pad" />
);
